import { FC } from "react";
import { ContainerProps, FlexDirection } from "../types";
import ContainerBase from "../container-base";

const Row: FC<ContainerProps> = (props) => {
  return (
    <ContainerBase
      {...props}
      flexDirection={
        props.reverse ? FlexDirection.RowReverse : FlexDirection.Row
      }
    >
      {props.children}
    </ContainerBase>
  );
};

export default Row;
